import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Typography, Row, Col, Button, Space } from "antd";
import axiosInstance from "../../../../configs";
import dayjs from "dayjs";
import "dayjs/locale/id"; // Import Indonesian locale

dayjs.locale("id");

const { Title, Text } = Typography;

export default function PemusnahanPrint() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (id) {
            axiosInstance.get(`/pemusnahan/${id}`)
                .then(res => {
                    const fetched = res.data.data ? res.data.data : res.data;
                    setData(fetched);
                })
                .catch(err => console.error(err))
                .finally(() => setLoading(false));
        }
    }, [id]);

    if (loading) return <div>Loading...</div>;
    if (!data) return <div>Data not found</div>;

    const items = data.details || [];
    const itemHeader = data;

    const formattedDate = itemHeader.tanggal_pemusnahan
        ? dayjs(itemHeader.tanggal_pemusnahan).format("D MMMM YYYY")
        : "-";

    return (
        <div style={{ padding: 40, fontFamily: 'Arial, sans-serif', maxWidth: 800, margin: '0 auto', background: "white" }}>
            {/* Header / Kop */}
            <div style={{ textAlign: "center", marginBottom: 20 }}>
                <img
                    src="/assets/media/logos/alb.png"
                    alt="ALB Logo"
                    style={{ width: 100, display: "block", margin: "0 auto 10px auto" }}
                />
            </div>

            <div style={{ textAlign: "center", marginBottom: 30 }}>
                <Title level={4} style={{ margin: 0, textTransform: "uppercase", textDecoration: "underline" }}>
                    BERITA ACARA PEMUSNAHAN BARANG
                </Title>
                <Text>Nomor BA: {itemHeader.no_ba_pemusnahan || "-"}</Text>
            </div>

            {/* Info Table */}
            <table style={{ width: "100%", marginBottom: 20, fontSize: 13, border: "none" }}>
                <tbody>
                    <tr>
                        <td style={{ width: 180, fontWeight: "bold" }}>Nomor Pengajuan</td>
                        <td style={{ width: 10 }}>:</td>
                        <td>{itemHeader.no_pemusnahan}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: "bold" }}>Tanggal Pemusnahan</td>
                        <td>:</td>
                        <td>{formattedDate}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: "bold" }}>No. Persetujuan KPPBC</td>
                        <td>:</td>
                        <td>{itemHeader.no_persetujuan_kppbc || "-"}</td>
                    </tr>
                    <tr>
                        <td style={{ fontWeight: "bold" }}>Tgl. Persetujuan KPPBC</td>
                        <td>:</td>
                        <td>{itemHeader.tanggal_persetujuan_kppbc ? dayjs(itemHeader.tanggal_persetujuan_kppbc).format("DD-MM-YYYY") : "-"}</td>
                    </tr>
                </tbody>
            </table>

            <div style={{ marginBottom: 10, fontSize: 13 }}>
                <Text>Telah dilaksanakan pemusnahan barang dengan rincian sebagai berikut:</Text>
            </div>

            {/* Item Table */}
            <table style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #000", marginBottom: 20, fontSize: 12 }}>
                <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center", width: 40 }}>No.</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "left" }}>Kode Barang</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "left" }}>Nama Barang</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>Lot Asal</th>
                        <th style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>Jml Dimusnahkan</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{index + 1}</td>
                            <td style={{ border: "1px solid #000", padding: "6px" }}>{item.item_code}</td>
                            <td style={{ border: "1px solid #000", padding: "6px" }}>{item.item_name || "-"}</td>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{item.lot_asal}</td>
                            <td style={{ border: "1px solid #000", padding: "6px", textAlign: "center" }}>{item.jumlah_kemasan_tujuan}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div style={{ marginBottom: 10, fontSize: 13 }}>
                <Text>Catatan / Keterangan: {itemHeader.catatan || "-"}</Text>
            </div>

            {/* Signatures */}
            <Row style={{ marginTop: 50, fontSize: 12 }}>
                <Col span={8} style={{ textAlign: "center" }}>
                    <div>Dibuat Oleh,</div>
                    <div style={{ marginTop: 70, borderBottom: "1px solid #000", width: "80%", margin: "70px auto 0 auto" }}></div>
                    <div>( Admin Gudang )</div>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                    <div>Disetujui Oleh,</div>
                    <div style={{ marginTop: 70, borderBottom: "1px solid #000", width: "80%", margin: "70px auto 0 auto" }}></div>
                    <div>( Pimpinan )</div>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                    <div>Mengetahui,</div>
                    <div style={{ marginTop: 70, borderBottom: "1px solid #000", width: "80%", margin: "70px auto 0 auto" }}></div>
                    <div>( Petugas BC )</div>
                </Col>
            </Row>

            <style>{`
                @media print {
                    .print-controls { display: none !important; }
                    @page { margin: 2cm; }
                    body { -webkit-print-color-adjust: exact; background: white; }
                }
            `}</style>

            <div className="print-controls" style={{ marginTop: 40, textAlign: 'center' }}>
                <Button type="primary" onClick={() => window.print()}>Print / Cetak</Button>
            </div>
        </div>
    );
}
